/*------------------------------------*\
    account
\*------------------------------------*/
module.exports = function(){



    /*------------------------------------*\
        All Countries Codes
    \*------------------------------------*/
    var CountryCodes = [
        { value: 'CA', text: 'Canada' },
        { value: 'US', text: 'United States' },
        { value: 'BD', text: 'Bangladesh' },
        { value: 'BE', text: 'Belgium' },
        { value: 'BF', text: 'Burkina Faso' },
        { value: 'BG', text: 'Bulgaria' },
        { value: 'BA', text: 'Bosnia and Herzegovina' },
        { value: 'BB', text: 'Barbados' },
        { value: 'WF', text: 'Wallis and Futuna' },
        { value: 'BL', text: 'Saint Barthelemy' },
        { value: 'BM', text: 'Bermuda' },
        { value: 'BN', text: 'Brunei' },
        { value: 'BO', text: 'Bolivia' },
        { value: 'BH', text: 'Bahrain' },
        { value: 'BI', text: 'Burundi' },
        { value: 'BJ', text: 'Benin' },
        { value: 'BT', text: 'Bhutan' },
        { value: 'JM', text: 'Jamaica' },
        { value: 'BV', text: 'Bouvet Island' },
        { value: 'BW', text: 'Botswana' },
        { value: 'WS', text: 'Samoa' },
        { value: 'BQ', text: 'Bonaire, Saint Eustatius and Saba ' },
        { value: 'BR', text: 'Brazil' },
        { value: 'BS', text: 'Bahamas' },
        { value: 'JE', text: 'Jersey' },
        { value: 'BY', text: 'Belarus' },
        { value: 'BZ', text: 'Belize' },
        { value: 'RU', text: 'Russia' },
        { value: 'RW', text: 'Rwanda' },
        { value: 'RS', text: 'Serbia' },
        { value: 'TL', text: 'East Timor' },
        { value: 'RE', text: 'Reunion' },
        { value: 'TM', text: 'Turkmenistan' },
        { value: 'TJ', text: 'Tajikistan' },
        { value: 'RO', text: 'Romania' },
        { value: 'TK', text: 'Tokelau' },
        { value: 'GW', text: 'Guinea-Bissau' },
        { value: 'GU', text: 'Guam' },
        { value: 'GT', text: 'Guatemala' },
        { value: 'GS', text: 'South Georgia and the South Sandwich Islands' },
        { value: 'GR', text: 'Greece' },
        { value: 'GQ', text: 'Equatorial Guinea' },
        { value: 'GP', text: 'Guadeloupe' },
        { value: 'JP', text: 'Japan' },
        { value: 'GY', text: 'Guyana' },
        { value: 'GG', text: 'Guernsey' },
        { value: 'GF', text: 'French Guiana' },
        { value: 'GE', text: 'Georgia' },
        { value: 'GD', text: 'Grenada' },
        { value: 'GB', text: 'United Kingdom' },
        { value: 'GA', text: 'Gabon' },
        { value: 'SV', text: 'El Salvador' },
        { value: 'GN', text: 'Guinea' },
        { value: 'GM', text: 'Gambia' },
        { value: 'GL', text: 'Greenland' },
        { value: 'GI', text: 'Gibraltar' },
        { value: 'GH', text: 'Ghana' },
        { value: 'OM', text: 'Oman' },
        { value: 'TN', text: 'Tunisia' },
        { value: 'JO', text: 'Jordan' },
        { value: 'HR', text: 'Croatia' },
        { value: 'HT', text: 'Haiti' },
        { value: 'HU', text: 'Hungary' },
        { value: 'HK', text: 'Hong Kong' },
        { value: 'HN', text: 'Honduras' },
        { value: 'HM', text: 'Heard Island and McDonald Islands' },
        { value: 'VE', text: 'Venezuela' },
        { value: 'PR', text: 'Puerto Rico' },
        { value: 'PS', text: 'Palestinian Territory' },
        { value: 'PW', text: 'Palau' },
        { value: 'PT', text: 'Portugal' },
        { value: 'SJ', text: 'Svalbard and Jan Mayen' },
        { value: 'PY', text: 'Paraguay' },
        { value: 'IQ', text: 'Iraq' },
        { value: 'PA', text: 'Panama' },
        { value: 'PF', text: 'French Polynesia' },
        { value: 'PG', text: 'Papua New Guinea' },
        { value: 'PE', text: 'Peru' },
        { value: 'PK', text: 'Pakistan' },
        { value: 'PH', text: 'Philippines' },
        { value: 'PN', text: 'Pitcairn' },
        { value: 'PL', text: 'Poland' },
        { value: 'PM', text: 'Saint Pierre and Miquelon' },
        { value: 'ZM', text: 'Zambia' },
        { value: 'EH', text: 'Western Sahara' },
        { value: 'EE', text: 'Estonia' },
        { value: 'EG', text: 'Egypt' },
        { value: 'ZA', text: 'South Africa' },
        { value: 'EC', text: 'Ecuador' },
        { value: 'IT', text: 'Italy' },
        { value: 'VN', text: 'Vietnam' },
        { value: 'SB', text: 'Solomon Islands' },
        { value: 'ET', text: 'Ethiopia' },
        { value: 'SO', text: 'Somalia' },
        { value: 'ZW', text: 'Zimbabwe' },
        { value: 'SA', text: 'Saudi Arabia' },
        { value: 'ES', text: 'Spain' },
        { value: 'ER', text: 'Eritrea' },
        { value: 'ME', text: 'Montenegro' },
        { value: 'MD', text: 'Moldova' },
        { value: 'MG', text: 'Madagascar' },
        { value: 'MF', text: 'Saint Martin' },
        { value: 'MA', text: 'Morocco' },
        { value: 'MC', text: 'Monaco' },
        { value: 'UZ', text: 'Uzbekistan' },
        { value: 'MM', text: 'Myanmar' },
        { value: 'ML', text: 'Mali' },
        { value: 'MO', text: 'Macao' },
        { value: 'MN', text: 'Mongolia' },
        { value: 'MH', text: 'Marshall Islands' },
        { value: 'MK', text: 'Macedonia' },
        { value: 'MU', text: 'Mauritius' },
        { value: 'MT', text: 'Malta' },
        { value: 'MW', text: 'Malawi' },
        { value: 'MV', text: 'Maldives' },
        { value: 'MQ', text: 'Martinique' },
        { value: 'MP', text: 'Northern Mariana Islands' },
        { value: 'MS', text: 'Montserrat' },
        { value: 'MR', text: 'Mauritania' },
        { value: 'IM', text: 'Isle of Man' },
        { value: 'UG', text: 'Uganda' },
        { value: 'TZ', text: 'Tanzania' },
        { value: 'MY', text: 'Malaysia' },
        { value: 'MX', text: 'Mexico' },
        { value: 'IL', text: 'Israel' },
        { value: 'FR', text: 'France' },
        { value: 'IO', text: 'British Indian Ocean Territory' },
        { value: 'SH', text: 'Saint Helena' },
        { value: 'FI', text: 'Finland' },
        { value: 'FJ', text: 'Fiji' },
        { value: 'FK', text: 'Falkland Islands' },
        { value: 'FM', text: 'Micronesia' },
        { value: 'FO', text: 'Faroe Islands' },
        { value: 'NI', text: 'Nicaragua' },
        { value: 'NL', text: 'Netherlands' },
        { value: 'NO', text: 'Norway' },
        { value: 'NA', text: 'Namibia' },
        { value: 'VU', text: 'Vanuatu' },
        { value: 'NC', text: 'New Caledonia' },
        { value: 'NE', text: 'Niger' },
        { value: 'NF', text: 'Norfolk Island' },
        { value: 'NG', text: 'Nigeria' },
        { value: 'NZ', text: 'New Zealand' },
        { value: 'NP', text: 'Nepal' },
        { value: 'NR', text: 'Nauru' },
        { value: 'NU', text: 'Niue' },
        { value: 'CK', text: 'Cook Islands' },
        { value: 'XK', text: 'Kosovo' },
        { value: 'CI', text: 'Ivory Coast' },
        { value: 'CH', text: 'Switzerland' },
        { value: 'CO', text: 'Colombia' },
        { value: 'CN', text: 'China' },
        { value: 'CM', text: 'Cameroon' },
        { value: 'CL', text: 'Chile' },
        { value: 'CC', text: 'Cocos Islands' },
        { value: 'CG', text: 'Republic of the Congo' },
        { value: 'CF', text: 'Central African Republic' },
        { value: 'CD', text: 'Democratic Republic of the Congo' },
        { value: 'CZ', text: 'Czech Republic' },
        { value: 'CY', text: 'Cyprus' },
        { value: 'CX', text: 'Christmas Island' },
        { value: 'CR', text: 'Costa Rica' },
        { value: 'CW', text: 'Curacao' },
        { value: 'CV', text: 'Cape Verde' },
        { value: 'CU', text: 'Cuba' },
        { value: 'SZ', text: 'Swaziland' },
        { value: 'SY', text: 'Syria' },
        { value: 'SX', text: 'Sint Maarten' },
        { value: 'KG', text: 'Kyrgyzstan' },
        { value: 'KE', text: 'Kenya' },
        { value: 'SS', text: 'South Sudan' },
        { value: 'SR', text: 'Suriname' },
        { value: 'KI', text: 'Kiribati' },
        { value: 'KH', text: 'Cambodia' },
        { value: 'KN', text: 'Saint Kitts and Nevis' },
        { value: 'KM', text: 'Comoros' },
        { value: 'ST', text: 'Sao Tome and Principe' },
        { value: 'SK', text: 'Slovakia' },
        { value: 'KR', text: 'South Korea' },
        { value: 'SI', text: 'Slovenia' },
        { value: 'KP', text: 'North Korea' },
        { value: 'KW', text: 'Kuwait' },
        { value: 'SN', text: 'Senegal' },
        { value: 'SM', text: 'San Marino' },
        { value: 'SL', text: 'Sierra Leone' },
        { value: 'SC', text: 'Seychelles' },
        { value: 'KZ', text: 'Kazakhstan' },
        { value: 'KY', text: 'Cayman Islands' },
        { value: 'SG', text: 'Singapore' },
        { value: 'SE', text: 'Sweden' },
        { value: 'SD', text: 'Sudan' },
        { value: 'DO', text: 'Dominican Republic' },
        { value: 'DM', text: 'Dominica' },
        { value: 'DJ', text: 'Djibouti' },
        { value: 'DK', text: 'Denmark' },
        { value: 'VG', text: 'British Virgin Islands' },
        { value: 'DE', text: 'Germany' },
        { value: 'YE', text: 'Yemen' },
        { value: 'DZ', text: 'Algeria' },
        { value: 'UY', text: 'Uruguay' },
        { value: 'YT', text: 'Mayotte' },
        { value: 'UM', text: 'United States Minor Outlying Islands' },
        { value: 'LB', text: 'Lebanon' },
        { value: 'LC', text: 'Saint Lucia' },
        { value: 'LA', text: 'Laos' },
        { value: 'TV', text: 'Tuvalu' },
        { value: 'TW', text: 'Taiwan' },
        { value: 'TT', text: 'Trinidad and Tobago' },
        { value: 'TR', text: 'Turkey' },
        { value: 'LK', text: 'Sri Lanka' },
        { value: 'LI', text: 'Liechtenstein' },
        { value: 'LV', text: 'Latvia' },
        { value: 'TO', text: 'Tonga' },
        { value: 'LT', text: 'Lithuania' },
        { value: 'LU', text: 'Luxembourg' },
        { value: 'LR', text: 'Liberia' },
        { value: 'LS', text: 'Lesotho' },
        { value: 'TH', text: 'Thailand' },
        { value: 'TF', text: 'French Southern Territories' },
        { value: 'TG', text: 'Togo' },
        { value: 'TD', text: 'Chad' },
        { value: 'TC', text: 'Turks and Caicos Islands' },
        { value: 'LY', text: 'Libya' },
        { value: 'VA', text: 'Vatican' },
        { value: 'VC', text: 'Saint Vincent and the Grenadines' },
        { value: 'AE', text: 'United Arab Emirates' },
        { value: 'AD', text: 'Andorra' },
        { value: 'AG', text: 'Antigua and Barbuda' },
        { value: 'AF', text: 'Afghanistan' },
        { value: 'AI', text: 'Anguilla' },
        { value: 'VI', text: 'U.S. Virgin Islands' },
        { value: 'IS', text: 'Iceland' },
        { value: 'IR', text: 'Iran' },
        { value: 'AM', text: 'Armenia' },
        { value: 'AL', text: 'Albania' },
        { value: 'AO', text: 'Angola' },
        { value: 'AQ', text: 'Antarctica' },
        { value: 'AS', text: 'American Samoa' },
        { value: 'AR', text: 'Argentina' },
        { value: 'AU', text: 'Australia' },
        { value: 'AT', text: 'Austria' },
        { value: 'AW', text: 'Aruba' },
        { value: 'IN', text: 'India' },
        { value: 'AX', text: 'Aland Islands' },
        { value: 'AZ', text: 'Azerbaijan' },
        { value: 'IE', text: 'Ireland' },
        { value: 'ID', text: 'Indonesia' },
        { value: 'UA', text: 'Ukraine' },
        { value: 'QA', text: 'Qatar' },
        { value: 'MZ', text: 'Mozambique' },
    ];





    /*------------------------------------*\
        States of USA & Canada
    \*------------------------------------*/
    var USAStates = [
        { value: 'AL', text: 'Alabama' },
        { value: 'AK', text: 'Alaska' },
        { value: 'AS', text: 'American Samoa' },
        { value: 'AZ', text: 'Arizona' },
        { value: 'AR', text: 'Arkansas' },
        { value: 'CA', text: 'California' },
        { value: 'CO', text: 'Colorado' },
        { value: 'CT', text: 'Connecticut' },
        { value: 'DE', text: 'Delaware' },
        //{ value: 'DC', text: 'District Of Columbia' },
        //{ value: 'FM', text: 'Federated States Of Micronesia' },
        { value: 'FL', text: 'Florida' },
        { value: 'GA', text: 'Georgia' },
        { value: 'GU', text: 'Guam' },
        { value: 'HI', text: 'Hawaii' },
        { value: 'ID', text: 'Idaho' },
        { value: 'IL', text: 'Illinois' },
        { value: 'IN', text: 'Indiana' },
        { value: 'IA', text: 'Iowa' },
        { value: 'KS', text: 'Kansas' },
        { value: 'KY', text: 'Kentucky' },
        { value: 'LA', text: 'Louisiana' },
        { value: 'ME', text: 'Maine' },
        //{ value: 'MH', text: 'Marshall Islands' },
        { value: 'MD', text: 'Maryland' },
        { value: 'MA', text: 'Massachusetts' },
        { value: 'MI', text: 'Michigan' },
        { value: 'MN', text: 'Minnesota' },
        { value: 'MS', text: 'Mississippi' },
        { value: 'MO', text: 'Missouri' },
        { value: 'MT', text: 'Montana' },
        { value: 'NE', text: 'Nebraska' },
        { value: 'NV', text: 'Nevada' },
        { value: 'NH', text: 'New Hampshire' },
        { value: 'NJ', text: 'New Jersey' },
        { value: 'NM', text: 'New Mexico' },
        { value: 'NY', text: 'New York' },
        { value: 'NC', text: 'North Carolina' },
        { value: 'ND', text: 'North Dakota' },
        { value: 'MP', text: 'Northern Mariana Islands' },
        { value: 'OH', text: 'Ohio' },
        { value: 'OK', text: 'Oklahoma' },
        { value: 'OR', text: 'Oregon' },
        //{ value: 'PW', text: 'Palau' },
        { value: 'PA', text: 'Pennsylvania' },
        { value: 'PR', text: 'Puerto Rico' },
        { value: 'RI', text: 'Rhode Island' },
        { value: 'SC', text: 'South Carolina' },
        { value: 'SD', text: 'South Dakota' },
        { value: 'TN', text: 'Tennessee' },
        { value: 'TX', text: 'Texas' },
        { value: 'UT', text: 'Utah' },
        { value: 'VT', text: 'Vermont' },
        { value: 'VI', text: 'U.S. Virgin Islands' },
        { value: 'VA', text: 'Virginia' },
        { value: 'WA', text: 'Washington' },
        { value: 'WV', text: 'West Virginia' },
        { value: 'WI', text: 'Wisconsin' },
        { value: 'WY', text: 'Wyoming' },
    ];


    var CanadaStates = [
        { value: 'AB', text: 'Alberta' },
        { value: 'BC', text: 'British Columbia' },
        { value: 'MB', text: 'Manitoba' },
        { value: 'NB', text: 'New Brunswick' },
        { value: 'NL', text: 'Newfoundland and Labrador' },
        { value: 'NS', text: 'Nova Scotia' },
        { value: 'NU', text: 'Nunavut' },
        { value: 'NT', text: 'Northwest Territories' },
        { value: 'ON', text: 'Ontario' },
        { value: 'PE', text: 'Prince Edward Island' },
        { value: 'QC', text: 'Quebec' },
        { value: 'SK', text: 'Saskatchewan' },
        { value: 'YT', text: 'Yukon Territory' },
    ];



    var OtherStates = [
        { value: 'NA', text: 'N/A' },
    ];





    /*------------------------------------*\
        on tab open
    \*------------------------------------*/
    //$('.js-tab[data-tab='address']').on('tabopen', function(event) {
        //event.preventDefault();
    //});










    /*------------------------------------*\
        Parsley Set Up
    \*------------------------------------*/
    if ( $('.js-billing-address-form').length ) {
        $('.js-billing-address-form').parsley({
            errorsContainer: function(ParsleyField) {
                var selectWrapper = ParsleyField.$element.closest('.parsley-select-wrapper');
                if (selectWrapper.length > 0) {
                    return $(selectWrapper).find('.parsley-select-errors');
                }
                return ParsleyField;
            },
        });
    }



    if ( $('.js-home-address-form').length ) {
        $('.js-home-address-form').parsley({
            errorsContainer: function(ParsleyField) {
                var selectWrapper = ParsleyField.$element.closest('.parsley-select-wrapper');
                if (selectWrapper.length > 0) {
                    return $(selectWrapper).find('.parsley-select-errors');
                }
                return ParsleyField;
            },
        });
    }




    /*------------------------------------*\
        Selectize Setup
    \*------------------------------------*/
    var selectizeSetup = function(form, openDropdown, isUpdate) {

        // Country Elements
        var countrySelect = form.find('.js-address-country');
        var countrySelectize = countrySelect[0].selectize;


        //countrySelectize.clearOptions();
        countrySelectize.addOption(CountryCodes);
        countrySelectize.refreshOptions(0);


        // Set Initial Country Value
        if (!isUpdate) {
            if (typeof countrySelect.attr('data-initial') !== 'undefined') {
                countrySelectize.setValue( countrySelect.attr('data-initial') );
            }
        }



        // Hide Inputs for 'Other' Country
        //form.find('.js-other-location').removeClass('is-visible');
        //form.find('.js-address-state-wrapper').removeClass('is-hidden');




        // State Elements
        var stateSelect = form.find('.js-address-state');
        var stateSelectize = stateSelect[0].selectize;



        var disableDefaultSelects = function(){
            countrySelectize.$input.prop('disabled', true);
            countrySelectize.$input.prop('required', false);
            stateSelectize.$input.prop('disabled', true);
            stateSelectize.$input.prop('required', false);
        };




        // Add/Remove Options Based on Country Select Value
        var countryValue = countrySelect.val();
        switch (countryValue) {

            case 'CA':
                form.find('.js-address-state-wrapper').removeClass('u-visuallyhidden');
                stateSelectize.clearOptions();
                stateSelectize.addOption(CanadaStates);
                stateSelectize.refreshOptions(openDropdown);
                break;

            case 'US':
                form.find('.js-address-state-wrapper').removeClass('u-visuallyhidden');
                stateSelectize.clearOptions();
                stateSelectize.addOption(USAStates);
                stateSelectize.refreshOptions(openDropdown);
                break;

            default:
                stateSelectize.clearOptions();
                stateSelectize.addOption(OtherStates);
                stateSelectize.setValue('NA');
                stateSelectize.refreshOptions(0);
                form.find('.js-address-state-wrapper').addClass('u-visuallyhidden');

                //disableDefaultSelects();
                //form.find('.js-other-location').addClass('is-visible');
                //form.find('.js-other-location').find('input').prop('disabled', false);

                break;

        }




        // Set Initial State Value

        if (!isUpdate) {
            if (typeof stateSelect.attr('data-initial') !== 'undefined') {
                stateSelectize.setValue( stateSelect.attr('data-initial') );
            }
        }



    };


    $('.js-home-address-form').length ? selectizeSetup($('.js-home-address-form'), false, false) : null;
    $('.js-billing-address-form').length ? selectizeSetup($('.js-billing-address-form'), false, false) : null;









    /*------------------------------------*\
        On State Select Change
    \*------------------------------------*/
    $('.js-address-country').on('change', function(event) {
        event.preventDefault();
        selectizeSetup( $(this).closest('form'), true, true);
    });

    $('.js-home-address-form .js-address-country').on('sameasbillingcopied', function(event) {
        selectizeSetup( $('.js-home-address-form'), false, true);
    });









    /*------------------------------------*\
        Address Request Wrapper
    \*------------------------------------*/
    var addressRequestWrapper = function(form){



        if ( form.parsley().isValid() ) {




            var requestData = form.serializeFormJSON();






            /*------------------------------------*\
                StateProvinceCountry Value
            \*------------------------------------*/
            var CountryVal = form.find('.js-address-country').val();

            switch (CountryVal) {
                case 'US':
                    var CountryName = 'USA';
                    break;
                case 'CA':
                    var CountryName = 'Canada';
                    break;
                default:
                    var CountryName = 'Other';
                    break;
            }

            requestData.StateProvinceCountry = CountryName;






            /*------------------------------------*\
                StateProvinceAbbreviation Value
            \*------------------------------------*/
            var StateVal = form.find('.js-address-state').val();
            var StateAbbr = StateVal;

            if (CountryVal != 'US' && CountryVal != 'CA') {
                StateAbbr = 'NA';
            }

            requestData.StateProvinceAbbreviation = StateAbbr;







            form.find('.js-form-callback').removeClass('is-visible');

            /*------------------------------------*\
                Request
            \*------------------------------------*/
            $.ajax({
                url: form.attr('action'),
                type: form.attr('method'),
                dataType: 'json',
                headers: {
                    Authorization: 'Bearer ' + Cookies.get('JWT_ACCESS_TOKEN'),
                    Accept: 'application/json'
                },
                data: requestData,
                complete: function(jqXHR, textStatus){

                },

                success: function(data, textStatus, jqXHR){
                    form.find('.js-form-callback')
                        .text('Your address has been successfully changed.')
                        .addClass('is-visible')
                        .removeClass('is-error')
                        .addClass('is-success');

                    globalCustomerHomeAddresId = data.data.Id;

                },

                error: function(jqXHR, textStatus, errorThrown){
                    form.find('.js-form-callback')
                        .text(jqXHR.responseJSON.msg)
                        .addClass('is-visible')
                        .removeClass('is-success')
                        .addClass('is-error');

                },

            });




        }



    };






    /*------------------------------------*\
        Submit
    \*------------------------------------*/
    $('.js-home-address-form, .js-billing-address-form').on('submit', function(event) {
        event.preventDefault();
        addressRequestWrapper($(this));
    });





    $('.js-home-address-form.js-submit-on-change').find('input, select').on('change', debounce(function(event) {
        var form = $(this).closest('.js-home-address-form');
        addressRequestWrapper(form);

        eph.setSameAddress({
            value: 0,
            success: function(data, textStatus, jqXHR){
            },
            complete: function(jqXHR, textStatus){
            },
        });

    }, 200));





























































}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/addresses.js